// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main {
  font-family: var(--tertiary-font);
}

.CatalogCart_cart__43HBM {
  padding: 0 5rem;
  margin-top: 15rem;
}
@media only screen and (max-width: 37.5em) {
  .CatalogCart_cart__43HBM {
    padding: 0 2rem;
  }
}
.CatalogCart_cart__title__7bbN7 {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 3rem 0;
}
.CatalogCart_cart__title__7bbN7 h3 {
  font-size: 4rem;
  font-weight: 400;
  line-height: 4rem;
}
.CatalogCart_cart__items__grid__7T6xb {
  display: grid;
  grid-template-columns: 10rem 1fr 15rem;
}
@media only screen and (max-width: 25em) {
  .CatalogCart_cart__items__grid__7T6xb {
    grid-template-columns: 7rem 1fr 8rem;
  }
}
.CatalogCart_cart__items__head__hM8H3 {
  font-size: 1.4rem;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--color-grey);
  margin-bottom: 1rem;
}
.CatalogCart_cart__items__head__quantity__CBUHF {
  text-align: right;
  padding: 0 2rem;
}
@media only screen and (max-width: 37.5em) {
  .CatalogCart_cart__items__head__quantity__CBUHF {
    text-align: left;
  }
}
.CatalogCart_cart__items__body__fWOre {
  margin-bottom: 1rem;
}
@media only screen and (max-width: 37.5em) {
  .CatalogCart_cart__items__body__fWOre {
    margin-bottom: 2rem;
  }
}
.CatalogCart_cart__items__qty__WIVLE {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0 2rem;
}
@media only screen and (max-width: 37.5em) {
  .CatalogCart_cart__items__qty__WIVLE {
    flex-direction: column;
    justify-content: flex-start;
  }
}
.CatalogCart_cart__items__qty__group__rg13m {
  display: flex;
  align-items: center;
  gap: 1rem;
  height: fit-content;
}
.CatalogCart_cart__items__qty__group__rg13m button {
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  border: 1px solid var(--color-dark);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  cursor: pointer;
}
.CatalogCart_cart__items__qty__group__rg13m button:hover {
  background-color: var(--color-dark);
  color: var(--color-white);
}
.CatalogCart_cart__items__qty__group__rg13m input {
  background-color: transparent;
  width: 6rem;
  height: 4rem;
  padding-left: 2rem;
  font-weight: 600;
}
.CatalogCart_cart__items__delete__y-5Ic {
  cursor: pointer;
}
.CatalogCart_cart__items__delete__y-5Ic:hover {
  color: var(--color-error);
}
.CatalogCart_cart__items__subtotal__ahOtz {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
}
.CatalogCart_cart__empty__5Ta01 {
  padding: 3rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Catalogue/CatalogCart.module.scss"],"names":[],"mappings":"AAEA;EACI,iCAAA;AADJ;;AAIA;EACI,eAAA;EACA,iBAAA;AADJ;AAGI;EAJJ;IAKQ,eAAA;EAAN;AACF;AAEI;EACI,aAAA;EACA,SAAA;EACA,8BAAA;EACA,eAAA;AAAR;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAAZ;AAKQ;EACI,aAAA;EACA,sCAAA;AAHZ;AAKY;EAJJ;IAKQ,oCAAA;EAFd;AACF;AAKQ;EACI,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;AAHZ;AAKY;EACI,iBAAA;EACA,eAAA;AAHhB;AAKgB;EAJJ;IAKQ,gBAAA;EAFlB;AACF;AAMQ;EACI,mBAAA;AAJZ;AAMY;EAHJ;IAIQ,mBAAA;EAHd;AACF;AAMQ;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAJZ;AAMY;EANJ;IAOQ,sBAAA;IACA,2BAAA;EAHd;AACF;AAKY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAHhB;AAKgB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAHpB;AAMoB;EACI,mCAAA;EACA,yBAAA;AAJxB;AASgB;EACI,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAPpB;AAYQ;EACI,eAAA;AAVZ;AAYY;EACI,yBAAA;AAVhB;AAcQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;AAZZ;AAgBI;EACI,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAdR","sourcesContent":["@import '../variables/breakpoints';\n\nmain {\n    font-family: var(--tertiary-font);\n}\n\n.cart {\n    padding: 0 5rem;\n    margin-top: 15rem;\n\n    @media only screen and (max-width: $bp-600) {\n        padding: 0 2rem;\n    }\n\n    &__title {\n        display: flex;\n        gap: 1rem;\n        justify-content: space-between;\n        padding: 3rem 0;\n\n        h3 {\n            font-size: 4rem;\n            font-weight: 400;\n            line-height: 4rem;\n        }\n    }\n\n    &__items {\n        &__grid {\n            display: grid;\n            grid-template-columns: 10rem 1fr 15rem;\n\n            @media only screen and (max-width: $bp-400) {\n                grid-template-columns: 7rem 1fr 8rem;\n            }\n        }\n\n        &__head {\n            font-size: 1.4rem;\n            padding-bottom: 5px;\n            border-bottom: 1px solid var(--color-grey);\n            margin-bottom: 1rem;\n\n            &__quantity {\n                text-align: right;\n                padding: 0 2rem;\n\n                @media only screen and (max-width: $bp-600) {\n                    text-align: left;\n                }\n            }\n        }\n\n        &__body {\n            margin-bottom: 1rem;\n\n            @media only screen and (max-width: $bp-600) {\n                margin-bottom: 2rem;\n            }\n        }\n\n        &__qty {\n            display: flex;\n            justify-content: space-between;\n            gap: 1rem;\n            padding: 0 2rem;\n\n            @media only screen and (max-width: $bp-600) {\n                flex-direction: column;\n                justify-content: flex-start;\n            }\n\n            &__group {\n                display: flex;\n                align-items: center;\n                gap: 1rem;\n                height: fit-content;\n\n                button {\n                    border-radius: 50%;\n                    width: 4rem;\n                    height: 4rem;\n                    border: 1px solid var(--color-dark);\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    font-size: 2rem;\n                    cursor: pointer;\n\n\n                    &:hover {\n                        background-color: var(--color-dark);\n                        color: var(--color-white);\n\n                    }\n                }\n\n                input {\n                    background-color: transparent;\n                    width: 6rem;\n                    height: 4rem;\n                    padding-left: 2rem;\n                    font-weight: 600;\n                }\n            }\n        }\n\n        &__delete {\n            cursor: pointer;\n\n            &:hover {\n                color: var(--color-error);\n            }\n        }\n\n        &__subtotal {\n            display: flex;\n            flex-direction: column;\n            width: 100%;\n            align-items: flex-end;\n        }\n    }\n\n    &__empty {\n        padding: 3rem 0;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cart": `CatalogCart_cart__43HBM`,
	"cart__title": `CatalogCart_cart__title__7bbN7`,
	"cart__items__grid": `CatalogCart_cart__items__grid__7T6xb`,
	"cart__items__head": `CatalogCart_cart__items__head__hM8H3`,
	"cart__items__head__quantity": `CatalogCart_cart__items__head__quantity__CBUHF`,
	"cart__items__body": `CatalogCart_cart__items__body__fWOre`,
	"cart__items__qty": `CatalogCart_cart__items__qty__WIVLE`,
	"cart__items__qty__group": `CatalogCart_cart__items__qty__group__rg13m`,
	"cart__items__delete": `CatalogCart_cart__items__delete__y-5Ic`,
	"cart__items__subtotal": `CatalogCart_cart__items__subtotal__ahOtz`,
	"cart__empty": `CatalogCart_cart__empty__5Ta01`
};
export default ___CSS_LOADER_EXPORT___;
